import GameExperienceReport from '../../components/Report/GameExperience';

const GameExperienceReportPage = () => {
	return <GameExperienceReport />;
};

export default GameExperienceReportPage;
